export const COLUNAS_IMOBILIARIO = [
  { key: 'id', label: 'ID', sortable: true, tooltip: 'ID da obra' },
  {
    key: 'ufCidade',
    label: 'UF/CIDADE',
    sortable: true,
    tooltip: 'Estado e cidade da obra',
  },
  {
    key: 'empresa',
    label: 'EMP',
    sortable: true,
    tooltip: 'Empresa',
  },
  { key: 'obra', label: 'OBRA', sortable: true, tooltip: 'Nome da obra' },
  { key: 'fase', label: 'FASE', sortable: true, tooltip: 'Fase da obra' },
  { key: 'tipo', label: 'TIPO', sortable: true, tooltip: 'Tipo da obra' },
  {
    key: 'padrao',
    label: 'Padr\u00E3o ',
    sortable: true,
    tooltip: 'Padrão da obra',
  },
  {
    key: 'responsavel',
    label: 'RESPONSÁVEL',
    sortable: true,
    tooltip: 'Responsável',
  },
  {
    key: 'atualizada',
    label: 'ATUALIZADA',
    sortable: true,
    tooltip: 'Data da última atualização',
  },
];

export const COLUNAS_OUTROS = [
  { key: 'id', label: 'ID', sortable: true, tooltip: 'ID da obra' },
  {
    key: 'ufCidade',
    label: 'UF/CIDADE',
    sortable: true,
    tooltip: 'Estado e cidade da obra',
  },
  {
    key: 'empresa',
    label: 'EMPRESA',
    sortable: true,
    tooltip: 'Empresa responsável',
  },
  { key: 'obra', label: 'OBRA', sortable: true, tooltip: 'Nome da obra' },
  { key: 'fase', label: 'FASE', sortable: true, tooltip: 'Fase da obra' },
  { key: 'valor', label: 'VALOR', sortable: true, tooltip: 'Valor da obra' },
  {
    key: 'tipoObra',
    label: 'TIPO ',
    sortable: true,
    tooltip: 'Tipo de obra',
  },
  {
    key: 'responsavel',
    label: 'Responsável',
    sortable: true,
    tooltip: 'Responsável ',
  },
  {
    key: 'atualizada',
    label: 'ATUALIZADA',
    sortable: true,
    tooltip: 'Data da última atualização',
  },
];
